import { render, staticRenderFns } from "./CarbonFootprintAgreeDialog.vue?vue&type=template&id=31dfbc3e&scoped=true"
import script from "./CarbonFootprintAgreeDialog.vue?vue&type=script&lang=js"
export * from "./CarbonFootprintAgreeDialog.vue?vue&type=script&lang=js"
import style0 from "./CarbonFootprintAgreeDialog.vue?vue&type=style&index=0&id=31dfbc3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dfbc3e",
  null
  
)

export default component.exports